import { render, staticRenderFns } from "./IntelligentRobot.vue?vue&type=template&id=5b77b30b&scoped=true&"
import script from "./IntelligentRobot.vue?vue&type=script&lang=js&"
export * from "./IntelligentRobot.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentRobot.vue?vue&type=style&index=0&id=5b77b30b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77b30b",
  null
  
)

export default component.exports